import { Component } from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators
} from '@angular/forms';
import { Title } from '@angular/platform-browser';
import * as moment from 'moment';
import { Subject, takeUntil } from 'rxjs';
import { AuthService } from 'src/app/_services/auth.service';
import { ProfileService } from 'src/app/_services/profile.service';
import { TimesheetService } from 'src/app/_services/timesheet.service';
import { BaseComponent } from '../components/base/base.component';

export const valueLessThanOrEqualToBillingValidator: ValidatorFn = (
  group: AbstractControl
): ValidationErrors | null => {
  const billing = group.get('billing_value')?.value;
  const value = group.get('value')?.value;

  if (!billing || !value) return null;

  const billingDate = new Date(billing);
  const valueDate = new Date(value);

  return valueDate <= billingDate ? null : { valueGreaterThanBilling: true };
};

@Component({
  selector: 'app-time-sheet',
  templateUrl: './time-sheet.component.html',
  styleUrls: ['./time-sheet.component.css']
})
export class TimeSheetComponent extends BaseComponent {
  isMobile: boolean = false;
  isTablet: boolean = false;
  isDesktop: boolean = false;
  isModalOpen: boolean = false;
  isModalRequired: boolean = false;
  timePickerOpen: boolean = false;
  switchValue: boolean = false;

  selectedDate: Date | null = null;
  selectedWeek: { start: string; end: string } | null = null;
  note: string | null = null;
  type: 'value' | 'billing_value' = 'billing_value';
  listOfColumns: any[] = [];
  originalFormValue: any;

  userRole: string = '';
  chosenUser?: string;
  previousTime: string | null = null;

  indexProject: number;
  indexDay: number;
  maxDailyHours: number = 8;

  destroy$: Subject<void> = new Subject<void>();

  timeSheets: any[] = [];
  timeSheetsModal: any[] = [];
  profileData: any;
  selectedDay: any;
  minutesDayexclude: number;
  minutes: number = 0;
  totalHours: number = 0;
  dayHourtoexclude: number = 0;
  isReadOnly: boolean = false;

  totalTimeSheet: any = {
    alias: 'Totale',
    days: []
  };

  timeSheetForm: FormGroup;
  submissionForm: FormGroup;
  selectedDateHeader: string = '';
  selectedTotal: any;

  constructor(
    private readonly title: Title,
    private readonly timesheetService: TimesheetService,
    private readonly profileService: ProfileService,
    private readonly fb_timesheet: FormBuilder,
    private readonly authService: AuthService
  ) {
    super();
    this.setDefaultDate();
  }

  async ngOnInit() {
    this.utilityService.setTitle('Timesheet Fatturazione');
    this.title.setTitle('Timesheet | Sviluppo Personale');
    if (
      this.timesheetService.date != null &&
      this.timesheetService.chosenUser != null
    ) {
      this.selectedDate = this.timesheetService.date;
      this.selectedWeek!.start = moment(this.timesheetService.date).format(
        'yyyy-MM-DD'
      );
      this.chosenUser = this.timesheetService.chosenUser;
      this.timesheetService.date = null;
      this.timesheetService.chosenUser = null;

      this.authService.setChosenUser(this.chosenUser);
    } else {
      this.getTimesheet();
    }

    this.profileData = await this.profileService.getUserRoleAsync();
    this.userRole = this.profileData.roles[0].name;

    const screenWidth = window.innerWidth;

    if (screenWidth <= 567) {
      this.isMobile = true;
      this.isTablet = false;
      this.isDesktop = false;
    } else if (screenWidth >= 567 && screenWidth <= 900) {
      this.isTablet = true;
      this.isMobile = false;
      this.isDesktop = false;
    } else {
      this.isTablet = false;
      this.isMobile = false;
      this.isDesktop = true;
    }

    this._initForm();
  }

  getDayForProject(project: any): any {
    return project.days.find(
      (day: any) => day.date === this.selectedDateHeader
    );
  }

  /**
   * Funzione per creare e inizializzare il form di richiesta delle ore su TimeSheet
   */
  _initForm = () => {
    this.timeSheetForm = this.fb_timesheet.group({
      date: ['', Validators.required],
      projects: this.fb_timesheet.array([]),
      note: ['']
    });

    this.submissionForm = this.fb_timesheet.group({
      projects: this.fb_timesheet.array([])
    });
  };

  /* get projectsControl() {
    return (this.timeSheetForm.get('project') as FormArray).controls;
  } */

  get projectsControl() {
    const projects = this.timeSheetForm?.get('projects');
    return projects instanceof FormArray ? projects.controls : [];
  }

  /**
   * Funzione che serve per inserire/cambiare le ore nel time-picker
   * @param event nuova tempo inserita
   */
  changeTime(
    time: Date,
    projectId: number,
    userId: string,
    date: Date,
    type: string,
    i: number,
    j: number
  ) {
    this.indexProject = i;
    this.indexDay = j;
    if (this.timePickerOpen) {
      if (moment(time).format('HH:mm') != this.previousTime) {
        this.timesheetService
          .saveTimeSheet(
            moment(time).format('HH:mm'),
            projectId,
            userId,
            moment(date).format('YYYY-MM-DD'),
            type
          )
          .pipe(takeUntil(this.destroy$))
          .subscribe({
            next: (res: any) => {
              this.getTimesheet();
              this.responseToast('success', res.message);
            },
            error: (err: any) => {
              this.responseToast('error', err.error.error);
            }
          });
      }
    }
  }

  onTimePickerOpenChange(open: boolean, day: any) {
    if (open) {
      this.previousTime = moment(day.time).format('HH:mm'); // Salva il valore precedente quando il time picker si apre
    }
    this.timePickerOpen = open;
  }

  /**
   * Funzione che serve a recuperare tutta l'intera settimana selezionata
   * @param date data di inzio settimana
   * @returns void
   */
  onDateChange(date: Date): void {
    if (!date) {
      this.selectedWeek = null;
      return;
    }
    // andiamo a salvare l'inizio settimana e il fine settimana (venerdì)
    const startOfWeek = moment(date).startOf('isoWeek');
    const endOfWeek = moment(date).isoWeekday(5);

    this.selectedWeek = {
      start: startOfWeek.format('YYYY-MM-DD'),
      end: endOfWeek.format('YYYY-MM-DD')
    };
    this.selectedDate = startOfWeek.toDate(); // primo giorno della settimana
    this.getTimesheet();
  }

  /**
   * Funzione che serve per ricavare il lunedì della settimana corrente e impostarlo nel datepicker per filtrare la tabella
   */
  setDefaultDate(): void {
    const currentMonday = moment().startOf('isoWeek'); // Trova il lunedì della settimana corrente
    this.selectedDate = currentMonday.toDate(); // Imposta il date-picker con il lunedì corrente

    // Calcola l'intervallo della settimana (dal lunedì al venerdì)
    this.selectedWeek = {
      start: currentMonday.format('YYYY-MM-DD'),
      end: currentMonday.isoWeekday(5).format('YYYY-MM-DD')
    };
  }

  disableFutureDates = (current: Date): boolean => {
    // Disabilita tutte le date future rispetto ad oggi
    return current > new Date();
  };

  /**
   * Funzione che serve per tornare alla settimana precedente
   */
  previousWeek(): void {
    const previousMonday = moment(this.selectedDate)
      .subtract(1, 'week')
      .startOf('isoWeek');
    this.selectedDate = previousMonday.toDate();
    this.onDateChange(this.selectedDate);
  }

  /**
   * Funzione che serve per andare alla settimana successiva (solo se non supera la settimana corrente)
   */
  nextWeek(): void {
    const nextMonday = moment(this.selectedDate)
      .add(1, 'week')
      .startOf('isoWeek');
    if (!this.isNextWeekDisabled()) {
      this.selectedDate = nextMonday.toDate();
      this.onDateChange(this.selectedDate);
    }
  }

  /**
   * Funzione che serve per controllare se il pulsante "avanti" deve essere disabilitato
   * @returns true/false
   */
  isNextWeekDisabled(): boolean {
    const nextMonday = moment(this.selectedDate)
      .add(1, 'week')
      .startOf('isoWeek');
    const currentMonday = moment().startOf('isoWeek');
    return nextMonday.isAfter(currentMonday);
  }

  /**
   * Funzione che serve per disabilitare tutte le date che non sono di inizio settimana e tutte le date future
   * rispetto ad oggi
   * @param current Data corrente
   * @returns
   */
  disableNonStartOfWeek = (current: Date): boolean => {
    const today = moment().startOf('isoWeek'); // Lunedì della settimana corrente
    return (
      moment(current).isoWeekday() !== 1 ||
      moment(current).isAfter(today, 'week')
    );
  };

  /**
   * Funzione che serve per aprire la modale delle note
   * @param note nota salvata
   */
  openNoteModal(day: any, projectId: number, i: number, j: number) {
    this.selectedDay = day;
    this.selectedDay.id = projectId;
    this.indexProject = i;
    this.indexDay = j;
    this.isModalOpen = true;
    this.note = day.note;
  }

  /**
   * Funzione che serve per chiudere la modale senza salvare
   */
  closeModal() {
    this.isModalOpen = false;
  }

  saveNote() {
    // COMMENTATA PER NON FAR DARE ERRORE AL FE
    // this.timesheetService
    //   .saveNote(
    //     this.selectedDay.id,
    //     this.selectedDay.date,
    //     this.note!,
    //     !!this.chosenUser ? this.chosenUser : this.profileData?.id
    //   )
    //   .pipe(takeUntil(this.destroy$))
    //   .subscribe({
    //     next: (res: any) => {
    //       this.timeSheets[this.indexProject].days[this.indexDay].note =
    //         res.note;
    //       this.responseToast('success', res.message);
    //       this.closeModal();
    //     },
    //     error: (err: any) => {
    //       this.responseToast('error', err.error.error);
    //     }
    //   });
  }

  /**
   * Funzione che serve per chiamare la index dei timesheet
   */
  getTimesheet() {
    this.timesheetService
      .getTimesheet(this.chosenUser, this.selectedWeek?.start, this.type)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          res.projects.forEach((project: any) => {
            project.days.forEach((day: any) => {
              day.time = this.convertToTimeObject(
                !this.switchValue ? day.billing_value : day.value
              );
            });
          });

          const totalsConverted = res.totals.map((day: any) => {
            return {
              ...day,
              time: !this.switchValue ? day.billing_value : day.value
            };
          });

          this.listOfColumns = res.listOfColumns;
          this.timeSheets = res.projects;
          this.totalTimeSheet.days = totalsConverted;
        }
      });
  }

  /**
   * questa funzione serve per convertire una stringa (tempo) in una data
   * @param timeString stringa (tempo) da convertire in data
   * @returns ritorna un tipo data
   */
  convertToTimeObject(timeString: string): Date | null {
    if (
      !timeString ||
      typeof timeString !== 'string' ||
      !timeString.includes(':')
    )
      return null; // Gestione del valore nullo

    const [hours, minutes] = timeString.split(':').map(Number);
    const date = new Date();
    date.setHours(hours, minutes, 0, 0); // Imposta solo ore e minuti
    return date;
  }

  public getUserSelect($event: any): void {
    if (this.chosenUser != $event) {
      this.chosenUser = $event;
      this.getTimesheet();
    }
  }

  disabledHours(): number[] {
    return [9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24];
  }

  // getDisabledHoursForDay(day: any): () => number[] {
  //   return () => this.getDisabledHours(day);
  // }

  /**
   * questa funzione serve per calcolare le ore che devono essere siabilitate in base un determinato giorno
   * @param day giorno del progetto
   * @returns le ore da disabilitare
   */
  /*getDisabledHours(day: any): number[] {
    // Convertiamo l'ora corrente del progetto in numero decimale
    this.dayHourtoexclude = day.time ? this.convertTimeToFloat(day.time) : 0;

    // Prendiamo tutti i giorni da tutti i progetti
    let daysP = this.timeSheets.map((project) => project.days);

    // Filtriamo solo i giorni che corrispondono alla data selezionata
    let g = moment(day.date).format('YYYY-MM-DD');
    let d = daysP.flatMap((item) =>
      item.filter((d: any) => moment(d.date).format('YYYY-MM-DD') === g)
    );

    // Somma di tutte le ore del giorno in tutti i progetti
    const timesAsFloatLocal = d.map((item) =>
      this.convertTimeToFloat(item.time)
    );
    this.totalHours = timesAsFloatLocal.reduce((acc, val) => acc + val, 0);

    // Ore negli altri progetti (escluso questo)
    const otherProjectsHours = this.totalHours - this.dayHourtoexclude;

    // Calcoliamo quante ore ci restano disponibili nel giorno
    const remaining = 8 - otherProjectsHours;

    // Se hai già usato 8 ore o più, blocca tutte le ore
    if (remaining <= 0) {
      return [
        0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
        20, 21, 22, 23, 24,
      ];
    }

    // Costruiamo la lista di ore disponibili (a partire da 0 fino alle ore rimanenti)
    const enabledHours = Array.from({ length: remaining + 1 }, (_, i) => i);

    // Le ore da disabilitare saranno tutte le altre
    const allHours = [
      0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
      21, 22, 23, 24,
    ];
    const disabledHours = allHours.filter((h) => !enabledHours.includes(h));

    return disabledHours;
  }*/

  // FUNZIONE PER CONVERTIRE IL TEMPO IN DECIMALE
  /*convertTimeToFloat(time: string | null): number {
    if (!time) return 0;

    const date = new Date(time);
    return date.getHours() + date.getMinutes() / 60; // Fuso orario locale
  }*/
  // FUNZIONE PER DISABILITARE I MINUTI
  /*getDisabledMinutes = (hour: number): number[] => {
    // vado a calcolarmi le ore rimanenti escludendo quelle del progetto selezionato
    let remainingHours = 8 - this.totalHours + this.dayHourtoexclude;
    // se ancora non abbiamo settato nulla tornami tutti i minuti abilitati
    if (
      this.minutes == 0 &&
      hour != 8 &&
      remainingHours != 0 &&
      hour - remainingHours > 0
    ) {
      return [];
    }
    // se le ore che vogliamo inserire sono 8 andiamo a disabilitare tutti i minuti
    else if (this.minutes == 0 && remainingHours == 8 && hour == 8) {
      return Array.from({ length: 60 }, (_, i) => i + 1);
    }
    // se le ore totali - le ore che vogliamo inserire fa 0 vai a calcolare i minuti rimanenti e disabilita quelli che non possiamo inserire
    else if (
      Math.floor(remainingHours) - hour == 0 ||
      (remainingHours > 0 && remainingHours - hour > 0)
    ) {
      let minutes = (remainingHours - hour) * 60;
      return Array.from({ length: 60 - minutes }, (_, i) => minutes + i + 1);
    }

    // se nessuno degli altri controlli è verificato, vai a disabilitare tutti i minuti mancanti per arrivare
    // a un totale di 60 minuti rispetto a quelli già inseriti
    return Array.from(
      { length: this.minutes },
      (_, i) => 60 - this.minutes + 1 + i
    );
  };*/

  disabledMinutes(hour: number): number[] {
    if (hour == 8) {
      return Array.from({ length: 60 }, (_, i) => i + 1);
    }
    return [];
  }

  /**
   * Funzione per gestire il cambio di tabella (scrum/fatturazione)
   */
  onSwitchToggle = (): void => {
    this.switchValue = !this.switchValue;
    this.type = this.switchValue ? 'value' : 'billing_value';
    if (this.switchValue) {
      this.utilityService.setTitle('Timesheet Fatturazione');
      this.title.setTitle('Timesheet | Sviluppo Personale');
      this.utilityService.setTitle('Timesheet Scrum');
      this.title.setTitle('Timesheet | Sviluppo Personale');
    } else {
      this.utilityService.setTitle('Timesheet Fatturazione');
      this.title.setTitle('Timesheet | Sviluppo Personale');
    }
    this.getTimesheet();
  };

  /**
   * Funzione che parte appena si apre la modale per patchare i valori da visualizzare
   * @param data oggetto passato preso dalla index
   * @param day giorno selezionato
   */
  openModal = (
    data: any,
    day: string,
    note?: string,
    request?: string
  ): void => {
    // Inizializza il form (resettato)
    this._initForm();
    this.selectedDateHeader = day;
    this.timeSheetForm.patchValue({
      date: this.selectedDateHeader
    });

    if (request) {
      this.timeSheetForm.patchValue({
        note: note
      });
    }

    let formArrayName = this.timeSheetForm.get('projects') as FormArray;

    // andiamo ad escludere i progetti in cui quel giorno non hanno una sprint

    const filteredData = data.filter((key: any) => {
      const selectedDayData = key.days.find((d: any) => d.date === day);
      return (
        selectedDayData?.value != null && selectedDayData?.billing_value != null
      );
    });

    this.timeSheetsModal = filteredData;

    filteredData.forEach((key: any) => {
      const selectedDayData = key.days.find((d: any) => d.date === day);

      const group = this.fb_timesheet.group(
        {
          project_id: key.id,
          billing_value: this.convertToTimeObject(
            selectedDayData?.billing_value
          ),
          value: this.convertToTimeObject(selectedDayData?.value),
          initial_value: this.convertToTimeObject(selectedDayData?.value),
          initial_billing_value: this.convertToTimeObject(
            selectedDayData?.billing_value
          ),
          is_authorized: selectedDayData.is_authorized
        },
        {
          validators: [valueLessThanOrEqualToBillingValidator]
        }
      );

      // Quando cambia billing_value
      group.get('billing_value')?.valueChanges.subscribe(billing => {
        const scrum = group.get('value')?.value;

        if (!billing || !scrum) return;

        // Se billing < scrum → aggiorna scrum
        if (this.compareTimes(billing, scrum) < 0) {
          group.get('value')?.setValue(billing, { emitEvent: false });
        }
      });

      // Quando cambia scrum (value)
      group.get('value')?.valueChanges.subscribe(scrum => {
        const billing = group.get('billing_value')?.value;

        if (!scrum || !billing) return;

        // Se scrum > billing → aggiorna billing
        if (this.compareTimes(scrum, billing) > 0) {
          group.get('billing_value')?.setValue(scrum, { emitEvent: false });
        }
      });

      if (!request) {
        group.get('billing_value')?.valueChanges.subscribe(() => {
          this.updateTotalFromForm();
        });

        group.get('value')?.valueChanges.subscribe(() => {
          this.updateTotalFromForm();
        });

        this.isReadOnly = false;
      } else {
        this.isReadOnly = true;
      }

      formArrayName.push(group);
    });

    if (this.totalTimeSheet?.days) {
      this.selectedTotal = this.totalTimeSheet.days.find(
        (d: any) => d.date === day
      );
    }

    this.isModalRequired = true;
  };

  private compareTimes(t1: string | Date, t2: string | Date): number {
    const m1 = this.timeToMinutes(t1);
    const m2 = this.timeToMinutes(t2);
    return m1 - m2;
  }

  private timeToMinutes(time: string | Date): number {
    if (!time) return 0;

    if (typeof time === 'string') {
      const [h, m] = time.split(':').map(Number);
      return h * 60 + m;
    }

    return time.getHours() * 60 + time.getMinutes();
  }

  /**
   * Funzione che serve per salvare la richiesta delle ore
   */
  saveRequest = () => {
    this.timeSheetForm.value.projects.forEach((project: any) => {
      project.billing_value = moment(project.billing_value).format('HH:mm');
      project.value = moment(project.value).format('HH:mm');
    });

    this.timesheetService
      .requestTimesheet(this.getModifiedProjects())
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          this.responseToast('success', res.message);
          this.isModalRequired = false;
          this.getTimesheet();
        },
        error: (err: any) => {
          this.responseToast('error', err.error.message);
        }
      });
  };

  closeModalRequired = (): void => {
    this.isModalRequired = false;
    this.selectedDateHeader = '';
    this.selectedTotal = null;
    this._initForm(); // reset completo
  };

  sumTimes(times: Array<Date | string>): string {
    const totalMinutes = times.reduce(
      (acc, time) => acc + this.timeToMinutes(time),
      0
    );
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  }

  updateTotalFromForm() {
    const controls = (this.timeSheetForm.get('projects') as FormArray).controls;

    const billingTimes: Array<Date | string> = controls.map(
      c => c.get('billing_value')?.value
    );
    const valueTimes: Array<Date | string> = controls.map(
      c => c.get('value')?.value
    );

    this.selectedTotal = {
      billing_value: this.sumTimes(billingTimes),
      value: this.sumTimes(valueTimes)
    };
  }

  /**
   * Funzione che serve per confermare la richiesta
   */
  confirmRequest(userId: string, date: string) {
    let allProjects = this.timeSheetForm?.get('projects')?.value || [];

    /**
     * recupero i soli progetti per cui l'utente è autorizzato ad accettare la richiesta,
     * per cui è presente una richiesta in attesa nel giorno selezionato
     */
    let filteredProjects = allProjects.filter((project: any) => {
      const modalProject = this.timeSheetsModal.find(
        (p: any) => p.id === project.project_id
      );

      if (!modalProject) return false;

      // Trova il giorno selezionato in quel progetto
      const selectedDay = modalProject.days.find(
        (day: any) => day.date === this.selectedDateHeader
      );

      return project.is_authorized && selectedDay?.status === 'in_attesa';
    });

    let obj = {
      user_id: userId,
      date: date,
      projects: filteredProjects
    };

    this.timesheetService
      .confirmRequest(obj)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          this.responseToast('success', res.message);
          this.getTimesheet();
          this.closeModalRequired();
        },
        error: (err: any) => {
          this.responseToast('error', err.error.message);
        }
      });
  }

  isBillingValueDisabled(project: AbstractControl): boolean {
    return !project.get('billing_value')?.value;
  }

  isValueDisabled(project: AbstractControl): boolean {
    return !project.get('value')?.value;
  }

  getModifiedProjects(): any {
    const modifiedProjects: any[] = [];
    const projectsArray = this.timeSheetForm.get('projects') as FormArray;

    projectsArray.controls.forEach((group: AbstractControl) => {
      const formGroup = group as FormGroup;
      const value = this.formatTimeToString(formGroup.get('value')?.value);
      const initialValue = this.formatTimeToString(
        formGroup.get('initial_value')?.value
      );

      const billing = this.formatTimeToString(
        formGroup.get('billing_value')?.value
      );
      const initialBilling = this.formatTimeToString(
        formGroup.get('initial_billing_value')?.value
      );

      if (value !== initialValue || billing !== initialBilling) {
        modifiedProjects.push({
          project_id: formGroup.value.project_id,
          billing_value: billing,
          value: value
        });
      }
    });
    return {
      user_id: this.chosenUser || this.profileData?.id,
      projects: modifiedProjects,
      note: this.timeSheetForm.value.note,
      date: this.selectedDateHeader
    };
  }

  private formatTimeToString(date: Date | string): string {
    if (typeof date === 'string') return date;

    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /**
   * Funzione che alla modifica delle ore all'interno della modale di richiesta,
   * permette di verificare che il numero di ore inserite, non siano maggiori del limite massimo: 8
   *
   * Return true se c'è almeno un progetto che supera 8 ore
   * Return false se nessun progetto supera 8 ore
   */
  hasFinishMaxHours(): boolean {
    const projects = this.timeSheetForm.value.projects || [];

    for (let project of projects) {
      const billingMoment = moment(project.billing_value, 'HH:mm');
      const valueMoment = moment(project.value, 'HH:mm');

      const billingHours = billingMoment.hours() + billingMoment.minutes() / 60;
      const valueHours = valueMoment.hours() + valueMoment.minutes() / 60;

      if (billingHours > 8 || valueHours > 8) {
        return true; // c'è almeno un progetto che supera 8 ore
      }
    }
    return false; // nessun progetto supera 8 ore
  }
}
